'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _events = require('events');

var _lodashMaxby = require('lodash.maxby');

var _lodashMaxby2 = _interopRequireDefault(_lodashMaxby);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var Glyph = require('./Glyph.js');
var Spinner = require('./Spinner.js');

var loaderStack = _extends({}, _events.EventEmitter.prototype, {
    stack: [],
    addLoader: function addLoader(id) {
        var priority = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];

        if (this.getIndex(id) === -1) {
            this.stack.push({ id: id, priority: priority });
            this.emitChange();
        }
    },
    removeLoader: function removeLoader(id) {
        if (this.getIndex(id) !== -1) {
            this.stack.splice(this.getIndex(id), 1);
            this.emitChange();
        }
    },
    getIndex: function getIndex(id) {
        var idx = -1,
            obj = this.stack,
            totalObj = obj.length;
        for (var item = 0; item < totalObj; item++) {
            if (obj[item].id == id) {
                idx = item;
                break;
            }
        }
        return idx;
    },
    getMaxPriority: function getMaxPriority() {
        var max = (0, _lodashMaxby2['default'])(this.stack, function (loader) {
            return loader.priority;
        });
        return max ? max.priority : 0;
    },
    emitChange: function emitChange() {
        this.emit('change');
    },
    addChangeListener: function addChangeListener(callback) {
        this.on('change', callback);
    },
    removeChangeListener: function removeChangeListener(callback) {
        this.removeListener('change', callback);
    }
});

var Loader = (function (_React$Component) {
    _inherits(Loader, _React$Component);

    function Loader(props) {
        _classCallCheck(this, Loader);

        _get(Object.getPrototypeOf(Loader.prototype), 'constructor', this).call(this, props);
        this.state = {
            active: false
        };

        this.onStackChange = this.onStackChange.bind(this);
    }

    _createClass(Loader, [{
        key: 'getBackgroundStyles',
        value: function getBackgroundStyles() {
            var opacity = this.props.opacity;

            return {
                display: 'block',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, ' + opacity + ')'
            };
        }
    }, {
        key: 'getForegroundStyles',
        value: function getForegroundStyles() {
            return {
                display: 'table',
                width: '100%',
                height: '100%',
                textAlign: 'center'
            };
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this._stackId = _uuid2['default'].v4();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            loaderStack.addChangeListener(this.onStackChange);
            this.initialize(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.initialize(nextProps);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            loaderStack.removeChangeListener(this.onStackChange);
            loaderStack.removeLoader(this._stackId);
        }
    }, {
        key: 'initialize',
        value: function initialize(props) {
            if (props.show) {
                loaderStack.addLoader(this._stackId, props.priority);
            } else {
                loaderStack.removeLoader(this._stackId);
            }
        }
    }, {
        key: 'onStackChange',
        value: function onStackChange() {
            this.setState({
                active: loaderStack.getMaxPriority() === this.props.priority
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props;
            var backgroundStyle = _props.backgroundStyle;
            var children = _props.children;
            var contentBlur = _props.contentBlur;
            var disableDefaultStyles = _props.disableDefaultStyles;
            var foregroundStyle = _props.foregroundStyle;
            var hideContentOnLoad = _props.hideContentOnLoad;
            var style = _props.style;
            var show = _props.show;
            var id = _props.id;
            var active = this.state.active;

            var shouldShowLoader = !!active && !!show;

            var bgStyle = _extends({}, disableDefaultStyles ? {} : this.getBackgroundStyles(), backgroundStyle || {}, this.props.type === 'fixed' ? { position: 'fixed', zIndex: 1021 } : { position: 'absolute', zIndex: 1020 });

            var fgStyle = _extends({}, disableDefaultStyles ? {} : this.getForegroundStyles(), foregroundStyle || {});

            var loaderStyle = _extends({}, style);

            var contentStyle = _extends({
                position: 'relative',
                opacity: hideContentOnLoad && show ? 0 : 1
            }, shouldShowLoader && contentBlur ? {
                WebkitFilter: 'blur(' + contentBlur + 'px)',
                MozFilter: 'blur(' + contentBlur + 'px)',
                OFilter: 'blur(' + contentBlur + 'px)',
                msFilter: 'blur(' + contentBlur + 'px)',
                filter: 'blur(' + contentBlur + 'px)'
            } : {});

            var typeMap = {
                success: 'success',
                error: 'error',
                warning: 'warning',
                info: 'default'
            };

            var iconMap = {
                success: 'icon-circled-checkmark-large',
                error: 'icon-critical-large',
                warning: 'icon-attention-large',
                info: 'icon-info-large'
            };
            var sizeMap = {
                lg: 'large',
                sm: 'small',
                md: 'medium'
            };

            var showIcon = this.props.status === 'loading' ? _react2['default'].createElement(Spinner, { size: this.props.size }) : _react2['default'].createElement(
                'div',
                { className: 'Loader__icon' },
                _react2['default'].createElement(Glyph, {
                    type: typeMap[this.props.status],
                    size: sizeMap[this.props.size],
                    icon: iconMap[this.props.status]
                })
            );

            return shouldShowLoader ? _react2['default'].createElement(
                'div',
                { className: 'Loader', id: id, style: loaderStyle },
                _react2['default'].createElement(
                    'div',
                    { className: 'Loader__background', style: bgStyle },
                    _react2['default'].createElement(
                        'div',
                        { className: 'Loader__foreground', style: fgStyle },
                        _react2['default'].createElement(
                            'div',
                            { className: 'Loader__message' },
                            showIcon,
                            _react2['default'].createElement(
                                'div',
                                { className: 'Loader__content', style: contentStyle },
                                children
                            )
                        )
                    )
                )
            ) : false;
        }
    }]);

    return Loader;
})(_react2['default'].Component);

Loader.propTypes = {
    type: _propTypes2['default'].oneOf(['absolute', 'fixed']),
    backgroundStyle: _propTypes2['default'].object,
    children: _propTypes2['default'].node,
    // blur loader content while loading
    contentBlur: _propTypes2['default'].number,
    // disables all default styles if true
    disableDefaultStyles: _propTypes2['default'].bool,
    foregroundStyle: _propTypes2['default'].object,
    hideContentOnLoad: _propTypes2['default'].bool,
    id: _propTypes2['default'].string,
    // stack priority
    priority: _propTypes2['default'].number,
    show: _propTypes2['default'].bool.isRequired,
    style: _propTypes2['default'].object,
    status: _propTypes2['default'].oneOf(['loading', 'success', 'error', 'warning', 'info', 'none']),
    size: _propTypes2['default'].oneOf(['sm', 'md', 'lg']),
    opacity: _propTypes2['default'].number
};

Loader.defaultProps = {
    priority: 0,
    type: 'absolute',
    status: 'loading',
    opacity: 0.9,
    size: 'lg'
};

module.exports = Loader;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Loader.js
// module id = 969
// module chunks = 0 1